import Header from '@/components/Header';
import { Skeleton } from '@/components/ui/skeleton';

export function CompanyPageLoadingState() {
  return (
    <div role="status" aria-label="Carregando estabelecimento" className="bg-background min-h-screen pb-28">
      <Header showBack />

      <div className="relative h-56 overflow-hidden md:h-72 lg:h-80">
        <Skeleton className="h-full w-full rounded-none" />
      </div>

      <div className="container mt-6">
        <div className="lg:grid lg:grid-cols-[1fr_340px] lg:gap-8">
          <div className="space-y-10">
            <section>
              <div className="mb-4 flex items-center justify-between">
                <Skeleton className="h-7 w-32" />
                <Skeleton className="h-5 w-20" />
              </div>
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                {Array.from({ length: 6 }).map((_, index) => (
                  <div key={index} className="border-border bg-card rounded-xl border p-4">
                    <div className="space-y-3">
                      <Skeleton className="h-5 w-2/3" />
                      <Skeleton className="h-4 w-full" />
                      <Skeleton className="h-4 w-1/2" />
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <Skeleton className="mb-4 h-7 w-36" />
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                {Array.from({ length: 4 }).map((_, index) => (
                  <div key={index} className="border-border bg-card flex items-center gap-4 rounded-xl border p-4">
                    <Skeleton className="h-14 w-14 rounded-full" />
                    <div className="flex-1 space-y-2">
                      <Skeleton className="h-5 w-2/3" />
                      <Skeleton className="h-4 w-1/2" />
                      <Skeleton className="h-4 w-1/3" />
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>

          <aside className="hidden lg:block">
            <div className="sticky top-20 space-y-5">
              <Skeleton className="h-14 w-full rounded-xl" />
              <div className="border-border bg-card space-y-4 rounded-xl border p-5">
                <Skeleton className="h-6 w-32" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-5/6" />
                <Skeleton className="h-4 w-4/5" />
                <Skeleton className="h-4 w-3/4" />
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}
